import ACTION_NAMES from "actions/ACTION_NAMES";
import { generateReadOneActionCreator } from "actions/crudActionCreators";
import routes from "actions/routes";

export default {
    read: generateReadOneActionCreator(routes.API_CAMPAIGN, ACTION_NAMES.CAMPAIGN_SESSION_SUMMARY, 'session_summary'),
    readTextCampaignSessionsSummary: generateReadOneActionCreator(routes.API_CAMPAIGN, ACTION_NAMES.TEXT_CAMPAIGN_SESSION_SUMMARY, 'text_session_summary')
}
